import { motion } from "framer-motion";
import React from "react";
import { LeftArrow } from "shared/ui/icons/LeftArrow";
import { RightArrow } from "shared/ui/icons/RightArrow";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";

export const StandardProductModalFooter = ({
  setIsOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const goToCheckout = () => {
    window.location.href = isDevelopmentEnvironment()
      ? "/webshop/checkout"
      : "/winkelwagen";
  };
  return (
    <div className="gg-relative gg-col-span-9 gg-w-full gg-border-b gg-border-l gg-border-r gg-bg-white lg:gg-mt-[0.07rem]">
      <div className="gg-flex gg-justify-between gg-px-[1.563rem] gg-py-5">
        <div
          role="button"
          tabIndex={0}
          onClick={() => setIsOpen(false)}
          className="gg-group gg-flex gg-cursor-pointer gg-items-center gg-gap-1 gg-self-center gg-text-base gg-leading-4 gg-text-gray-500 gg-transition-all gg-ease-in-out hover:gg-text-gray-800"
        >
          <LeftArrow className="group-hover:gg-fill-black" />
          Verder winkelen
        </div>

        <motion.button
          onClick={goToCheckout}
          whileHover={{ scale: 1.012 }}
          whileTap={{ scale: 0.9 }}
          transition={{
            type: "easeInOut",
            stiffness: 400,
            damping: 17,
          }}
          className="gg-flex gg-cursor-pointer gg-items-center gg-gap-2 gg-whitespace-nowrap gg-rounded-sm gg-border-none gg-bg-yellow-300 gg-px-3 gg-py-1 gg-text-base gg-font-bold gg-leading-9 gg-text-dark-blue hover:gg-bg-opacity-90 sm:gg-gap-2.5 sm:gg-px-5 sm:gg-py-2 sm:gg-text-lg"
        >
          <span>Verder met bestellen</span>
          <RightArrow />
        </motion.button>
      </div>
    </div>
  );
};
